export default {"src":"/_next/static/media/2.6c57e7cd.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};